<style>

</style>

<svelte:window on:resize="{drawResize}"/>

<div bind:clientWidth="{width}">
	<canvas bind:this="{canvas}" width="{width}" height="{height}"></canvas>
</div>


<script>

export let me = -1;
export let them = -1;
export let type = "scale0-5";

let width = 0;
let height = 25;
let canvas = null;
let ctx = null;

$:{
  if (me >= 0 && them >= 0) setTimeout(paint, 100);
}

let repaint = null;
function drawResize(e) {
	clearTimeout(repaint);
	repaint = setTimeout(function() {
		paint();
	}, 100)
}


function paint() {
  // console.log("width:", width);
  if (canvas.getContext) {
		ctx = canvas.getContext("2d");
    
		ctx.clearRect(0, 0, width - 1, height);
    
    if (type == "scale0-5") {
      let tw = (width - 30) / 4;
      let cy = height / 2;
      
      ctx.strokeStyle = "lightgray";
      ctx.lineWidth = 1;
      
      for (let i = 0, x = 15; i <= width; i++) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
        ctx.stroke();
        x += tw;
      }
      
      ctx.beginPath();
      ctx.moveTo(15, cy);
      ctx.lineTo(width - 15, cy);
      ctx.stroke();
      
      let radius = height / 2;
      
      let lcx = 0;
      let rcx = 0;
      if (me == them) {
        lcx = ( (me - 1) * tw) + 7;
        rcx = ( (them - 1) * tw) + 13;
      } else {
        lcx = ( (me - 1) * tw) + 15;
        rcx = ( (them - 1) * tw) + 15;
      }
      
      if (me > 0) {
        // ctx.fillStyle = "#00d1ffaa";
        ctx.fillStyle = "#00d1ff";
        ctx.strokeStyle = "white";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(lcx, cy, radius, 0, 6.283185307179586);
        ctx.fill();
        // border
        // ctx.beginPath();
        // ctx.arc(lcx, cy, radius, 0, 6.283185307179586);
        // ctx.stroke();
      }
      
      
      if (them > 0) {
        // ctx.fillStyle = "#fff500aa";
        ctx.fillStyle = "#fff500";
        ctx.beginPath();
        ctx.arc(rcx, cy, radius, 0, 6.283185307179586);
        ctx.fill();
        // border
        // ctx.beginPath();
        // ctx.arc(rcx, cy, radius, 0, 6.283185307179586);
        // ctx.stroke();
      }
      
    }
  }
}

</script>